// extracted by mini-css-extract-plugin
module.exports = {"updateImageModal":"UpdateImageModal_updateImageModal__1NDPM","window":"UpdateImageModal_window__URBCt","button":"UpdateImageModal_button__dPWvD"};